<script setup lang="ts">
import ProjectParameterForm from '@/components/project-parameter-drawer/ProjectParameterForm.vue'
import OptionsDrawer from '@/components/drawer/OptionsDrawer.vue'
</script>

<template>
  <OptionsDrawer state-name="projectParameterDrawer" :temporary="true">
    <v-card elevation="0" class="pb-3 px-3">
      <v-card-title class="component-title px-0">Project parameters</v-card-title>
      <v-card-subtitle class="component-subtitle px-0"
        >Project parameters are the parameters that are used for the this project.
      </v-card-subtitle>
    </v-card>
    <v-divider />
    <ProjectParameterForm class="pt-3" />
  </OptionsDrawer>
</template>
